import { createSlice } from "@reduxjs/toolkit"

const tesisReducer = createSlice({
  name: "tesis",
  initialState: {
    tesis: null,
  },
  reducers: {
    setTesis: (state, action) => {
      state.tesis = action.payload
    },
    clearTesis: (state) => {
      state.tesis = null
    },
  },
})

export const { setTesis, clearTesis } = tesisReducer.actions
export default tesisReducer.reducer
